import { ReactElement, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Context as WikiContext } from "../../context/wikiContext/WikiContext";
import AssetManager from "../AssetManager";
import useResolvedLang from "../hooks/useResolvedLang";
import CustomModal from "./CustomModal";
import WikiInfoCarousel from "./WikiInfoCarousel";

const WikiModal: React.FC<WikiModalProps> = ({
  open,
  setOpen,
  children,
  wikiIDList,
}) => {
  const { state: wikiState, findWikis } = useContext(WikiContext);
  const { listedWikis } = wikiState;

  const [selectedIndex, setSelectedIndex] = useState<null | number>(null);
  const { i18n } = useTranslation();
  const lang = useResolvedLang();

  useEffect(() => {
    setSelectedIndex(null);

    findWikis(wikiIDList);

    return () => {};
  }, [wikiIDList]);

  function getWikiListContent() {
    return listedWikis.map((wiki, index) => (
      <div key={index} className="wiki-list-item-outer">
        <div
          className="wiki-list-item"
          onClick={() => {
            setSelectedIndex(index);
          }}
        >
          <div className="wiki-list-item-dot"></div>
          <p className="wiki-list-item-title">{wiki.choice[lang]}</p>
        </div>
        <div className="wiki-list-item-separator"></div>
      </div>
    ));
  }

  function getCustomModalContent() {
    return (
      <>
        {children}
        <div className="wiki-modal-header">
          <div className="wiki-details">
            <p className="wiki-modal-title">
              {i18n.t("wiki_modal_questions_title")}
            </p>

            <p className="wiki-modal-description">
              {i18n.t("wiki_modal_questions_description")}
            </p>
          </div>

          <div
            className="wiki-modal-close"
            onClick={() => {
              setOpen(false);
              setSelectedIndex(null);
            }}
          >
            <img
              src={AssetManager.getAsset("/close_icon.svg")}
              alt="close-icon"
            />
          </div>
        </div>
        <div className="wiki-list-container">{getWikiListContent()}</div>
      </>
    );
  }

  function getWikiDetailsContent() {
    if (selectedIndex !== null) {
      const selectedWiki = listedWikis[selectedIndex];

      return (
        <WikiInfoCarousel
          wiki={selectedWiki}
          backFunc={() => {
            setSelectedIndex(null);
          }}
          setOpen={setOpen}
        ></WikiInfoCarousel>
      );
    }

    return <></>;
  }

  return (
    <>
      <CustomModal
        open={open}
        setOpen={setOpen}
        containerClassName={selectedIndex === null ? "" : "wiki-info-modal"}
      >
        {selectedIndex === null
          ? getCustomModalContent()
          : getWikiDetailsContent()}
      </CustomModal>
    </>
  );
};

export default WikiModal;

export interface WikiModalProps {
  open: boolean;
  setOpen: (o: boolean) => void;
  children?: ReactElement;
  wikiIDList: number[];
}
